import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import Multiselect from "multiselect-react-dropdown";
import {
  AddCardOutlined,
  AddCircle,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor

function Add(props) {
  const [isEdit, setisEdit] = useState(false);

  const dispatch = useDispatch();

  const [displayDate, setDisplayDate] = useState("");
  const [years, setYears] = useState([]);

  let vendorType = "";
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";
  const [formData, setFormData] = useState({
    year: "",
    target: "",
  });

  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();
      if (isEdit) {
        bodyFormData.append("id", props?.rowData?.id);
        bodyFormData.append("client_id", userProfile?.employeeId);
      }

      bodyFormData.append("annual_year", formData.year);
      bodyFormData.append("target", formData.target);
      bodyFormData.append("dealership_id", props?.id);

      utils
        .callAPI("post", "/sales/save_annual_target", bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("yeah hai value", value, name);
    let validatedValue = value;

    if (name === "target") {
      // Remove non-digit characters and leading zeros
      validatedValue = value.replace(/\D/g, "").replace(/^0+(?!$)/, "");
      // Ensure the value does not exceed 10 characters
      if (validatedValue.length > 10) {
        validatedValue = validatedValue.slice(0, 10);
      }
    }

    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setisEdit(true);

      setFormData({
        year: props?.rowData?.annual_year || "",
        target: props?.rowData?.target || "",
      });
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  useEffect(() => {
    getYearList();
  }, []);

  const getYearList = () => {
    utils
      .callAPI("get", `/sales/getYearsList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setYears(res);
        } else {
          setYears([]);
        }
      })
      .catch((err) => {
        setYears([]);
      });
  };

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          {/* <h4>{isEdit ? `Edit ${vendorType}` : `Add ${vendorType}`}</h4> */}
          <h4>{isEdit ? `Edit Target` : `Add Target`}</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Row>
                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Select Target Year"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Select
                        name="year"
                        value={formData.year}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select Year...</option>
                        {years.map((year, index) => (
                          <option key={index} value={year}>
                            {year}
                          </option>
                        ))}
                      </RB.Form.Select>
                      {/* {bankErrors.bankName && (
                        <span className="text-danger">
                          {bankErrors.bankName}
                        </span>
                      )} */}
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              </RB.Row>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Target"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Target "
                      name="target"
                      value={formData.target}
                      onChange={handleInputChange}
                      required
                      maxLength={10}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
